export const WALLET_INFO_STORAGE_KEY = 'suigar.connection.wallet';
